import React from "react";

import { Text, TextDate } from "@performyard/py-components";

type InsightsGeneratedAtProps = {
	label: string;
	date: Date | string | null | undefined;
	/**
	 * Name of whoever triggered the generation, appended as "by <name>".
	 *
	 * Pass only a name the current viewer is authorized to see — this component does no gating.
	 * See MeetingWorkspaceInsight for the 1:1-vs-team-workspace disclosure rule.
	 */
	generatedBy?: string | null;
};

/**
 * The "when were these insights generated" line shown at the top of every AI panel.
 *
 * Renders as a single caption paragraph so the label, timestamp and author read as one
 * sentence to a screen reader rather than as three separate blocks.
 */
export const InsightsGeneratedAt = ({
	label,
	date,
	generatedBy,
}: InsightsGeneratedAtProps): React.ReactElement | null => {
	const generatedAt = date ? new Date(date) : null;

	if (!generatedAt || Number.isNaN(generatedAt.getTime())) return null;

	return (
		<Text size="caption" weight="regular" color="neutral-9" data-testid="insights-generated-at">
			{label}:{" "}
			<TextDate
				date={generatedAt}
				hasTime
				dateSize="medium"
				size="caption"
				weight="regular"
				color="neutral-9"
				overrideElement="span"
			/>
			{generatedBy ? ` by ${generatedBy}` : ""}
		</Text>
	);
};
